import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import Pagination from '@/components/ui/pagination/Pagination';
import AlphabetSearch from '@/components/ui/alphabet-search/AlphabetSearch';
import AuthorsList from '@/components/ui/authors-list/AuthorsList';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { AUTHORS_FOR_PAGE } from '@/helpers/variables';
import { IAuthorsPage } from '@/interfaces/authorsPage.interface';

import { getCurrentPageName } from '@/helpers/helpers';

interface IAuthors {
  authors: IAuthorsPage;
  letterSign?: string;
}

const Authors: FC<IAuthors> = ({ authors, letterSign }) => {
  const pagesCount = Math.ceil(authors?.total_count / AUTHORS_FOR_PAGE);

  const currentPath = String(useGetUrlPath());
  const isSearchLetterPage = currentPath.includes('letter');
  const currentPathSplit = currentPath.split('/');

  const getSearchLetterWord = () => {
    if (currentPath.includes('page=')) {
      return currentPathSplit[currentPathSplit.length - 2];
    }
    return currentPathSplit[currentPathSplit.length - 1];
  };

  //Seo block
  const SEO_TITLE = `Список авторов по алфавиту :: BookZ.ru${getCurrentPageName(authors.page)}`;
  const SEO_DESCRIPTION = 'Список авторов книг по алфавиту - читайте онлайн или скачивайте книги на сайте электронной библиотеки BookZ.ru.';
  const SEO_CANONICAL = '/authors';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} breadcrumbs={<Breadcrumbs firstPageName="Полный список авторов библиотеки" />}>
      <SectionTitle name="Полный список авторов библиотеки" />
      <AlphabetSearch url={'/authors/letter/'} letterSign={String(letterSign)} title="Авторы по алфавиту" />

      {!!authors.data.length ? <AuthorsList data={authors.data} /> : <div>{`Авторы не найдены`}</div>}

      {/* Проверка на страницы поиска по букве */}
      <Pagination pagesCount={pagesCount ?? 0} postName={!!isSearchLetterPage ? `authors/letter/${getSearchLetterWord()}/page=` : `authors/page=`} />
    </Layout>
  );
};

export default Authors;
